import LessonsList from './LessonsList';
import { Box, Button, Center, Flex, Heading, Icon } from '@chakra-ui/react';
import { Lesson } from '@opanuj/shared/types';
import { LuNotepadText } from 'react-icons/lu';
import { NavLink } from 'react-router-dom';

function renderNoLessonsMessage() {
	return <Center h="33%">
		<Flex flexDir="column" alignItems="center" gap={2} mb={10}>
			<Heading size="md" fontWeight='normal' my={5} color="gray.600" letterSpacing='wider'>
				Brak bieżących lekcji
			</Heading>
			<Button asChild size="sm" colorPalette="orange" variant="ghost" mr={2}>
				<NavLink to="/zapisy">
					<Icon as={LuNotepadText} boxSize={4} />
					Zapisz się
				</NavLink>
			</Button>
		</Flex>
	</Center>;
}

export type LessonsViewProps = {
	lessons: Lesson[];
}

export default function LessonsView({ lessons }: LessonsViewProps) {
	if (!lessons.length) {
		return (
			renderNoLessonsMessage()
		);
	}

	return (
		<Flex flexDir="column">
			<Box>
				<LessonsList lessons={lessons} />
			</Box>
		</Flex>
	);
}
